import { render } from "./UserConsulenzeRiepilogo.vue?vue&type=template&id=0eb9cce4&scoped=true"
import script from "./UserConsulenzeRiepilogo.vue?vue&type=script&lang=js"
export * from "./UserConsulenzeRiepilogo.vue?vue&type=script&lang=js"

import "./UserConsulenzeRiepilogo.vue?vue&type=style&index=0&id=0eb9cce4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb9cce4"]])

export default __exports__